module.exports = __webpack_public_path__ + "img/storage-2.878b2f1b.webp";